module.exports = __webpack_public_path__ + "media/banners/finansowanie-menu-5f66c6f5.png";